import "./DownloadCard.css";
import React from "react";
import { FiDownload } from "react-icons/fi";
import { HasPermission } from "../../services/hasPermission";

const DownloadCard = ({ icon = null, title = null, button = null }) => {
  return (
    <div className="pdf-card">
      <div className="pdf-icon">
        <div className="pdf-tag">PDF</div>
        <div className="pdf-symbol">🅰️</div>
        {/* You can replace this with an SVG */}
      </div>
      <div className="pdf-footer">
        <span className="pdf-name color-white">IDcard_lost.pdf</span>
        {HasPermission("Employee", "export") && (
          <button className="universal-round-btn">
            <FiDownload size={18} />
          </button>
        )}
      </div>
    </div>
  );
};

export default DownloadCard;
